<template>
  <v-card>
    <v-card-title class="accent--text">{{ InfoData.DP_NAZ }}</v-card-title>
    <v-card-text class="py-1 px-2 font-italic"><span class="primary--text">Inventární číslo: </span>{{ InfoData.DP_KOD }}</v-card-text>
    <v-card-text class="py-1 px-2">{{ InfoData.DP_TEMA }}</v-card-text>

    <div class="d-flex flex-row pa-2">
      <v-tooltip top v-for="item in InfoData_Docs" :key="item.uri">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" :href="item.uri" target="DemoDoc" class="mx-2">
            <v-icon large color="">mdi-clipboard-text</v-icon>
          </v-btn>
        </template>
        <span>{{ item.nazev }}</span>
      </v-tooltip>
    </div>

  </v-card>
</template>

<script>
export default {

  props: {
    // Adresa na Assets
    AssetsUrl: null,
    // data 
    InfoData: Object,

  },

  computed: {
    InfoData_Docs: function () {
      if (this.InfoData.DOC == null) { return [] } else { return JSON.parse(this.InfoData.DOC) }
    },

  },


}


</script>
